import React from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";

const SkeletonPageHeader = () => {
  return (
    <>
      <SkeletonTheme height={30}>
        <div className="row g-3 mb-5">
          <div className="col-6"></div>
          <div className="col-2">
            <Skeleton count={1} />
          </div>
          <div className="col-2">
            <Skeleton count={1} />
          </div>
          <div className="col-2">
            <Skeleton count={1} />
          </div>
        </div>
      </SkeletonTheme>
    </>
  );
};

export default SkeletonPageHeader;
